import { ReactElement } from 'react';

import { ApiErrorNotification } from './ApiErrorNotification';
import { ContentContainer } from './ContentContainer';

type Props = {
  error: Error | null;
};

export const PageApiError = ({ error }: Props): ReactElement | null => {
  if (!error) return null;

  return (
    <ContentContainer>
      <ApiErrorNotification error={error} />
    </ContentContainer>
  );
};
